import React from 'react';
import { Link } from 'react-scroll';
import { get as _get } from 'lodash';
import { Taxonomy, TravelContent } from 'types/locationView';
import { BreadCrumbs } from '../../types/breadCrumbs';
import resizeImage from '../../utils/resizeImage';
import config from '../../config';
import Breadcrumbs from '../Breadcrumbs';
import styles from './Hero.module.scss';

type Props = {
  travelContent: TravelContent;
  taxonomy: Taxonomy;
  breadCrumbs: BreadCrumbs;
  imageResizing: boolean;
};

const Hero: React.FC<Props> = ({ travelContent = null, taxonomy, breadCrumbs, imageResizing }) => {
  const getBackgroundImage = () => travelContent?.media?.large ?? config.defaultImageUrl;

  return (
    <div
      className={styles.hero}
      style={{
        backgroundImage: `url("${resizeImage(getBackgroundImage(), imageResizing)}")`,
      }}
    >
      <div className={styles.content}>
        {breadCrumbs && (
          <Breadcrumbs
            breadcrumbs={breadCrumbs.slice(0, -1)}
            baseUrl="/travel"
            className={styles.breadcrumbs}
          />
        )}
        <h1 id="hero-title">{taxonomy?.name} Travel &amp; Surf Guide</h1>
        <div className={styles.heading}>
          <h2 className={styles.subtitle}>
            {_get(travelContent, 'content.subtitle', null)
              ? travelContent?.content.subtitle
              : 'Get the best tips on local beaches, travel seasons and surf spots'}
          </h2>
        </div>
      </div>
      <Link className={styles.anchor} to="sl-travel-anchor" duration={300} smooth>
        <div className={styles.icon} />
      </Link>
    </div>
  );
};

export default Hero;
